import { mask } from 'remask';

export function unmaskCpf(value: string) {
  if (!value) return '';
  const cpf = ['99999999999'];

  return mask(value, cpf);
}
